function AlertingRenderer(props) {
    const { alertCondition, children } = props

    return <span className={alertCondition ? "text-alerting" : null}>
        {children}
    </span>
}

export default AlertingRenderer
